import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { DEFAULT_WHATSAPP_MESSAGE, whatsappLink } from "../lib/constants";

export function Footer() {
  return (
    <footer className="border-t-2 border-ink bg-white">
      <div className="mx-auto grid max-w-6xl gap-8 px-5 py-12 md:grid-cols-4">
        <div>
          <Logo className="h-8" />
          <p className="mt-4 max-w-[24ch] text-sm text-ink/60">
            Disparo de campanhas no WhatsApp e SMS voltado a empresas que precisam falar com muita
            gente de forma organizada.
          </p>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-ink/50">Produto</h3>
          <ul className="flex flex-col gap-2 text-sm">
            <li>
              <Link to="/whatsapp-web" className="text-ink/70 hover:text-ink hover:underline">
                API Web (QR Code)
              </Link>
            </li>
            <li>
              <Link to="/whatsapp-oficial" className="text-ink/70 hover:text-ink hover:underline">
                API Oficial da Meta
              </Link>
            </li>
            <li>
              <Link to="/sms" className="text-ink/70 hover:text-ink hover:underline">
                SMS em massa
              </Link>
            </li>
            <li>
              <Link to="/planos" className="text-ink/70 hover:text-ink hover:underline">
                Planos e preços
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-ink/50">Empresa</h3>
          <ul className="flex flex-col gap-2 text-sm">
            <li>
              <a
                href={whatsappLink(DEFAULT_WHATSAPP_MESSAGE)}
                target="_blank"
                rel="noreferrer"
                className="text-ink/70 hover:text-ink hover:underline"
              >
                Falar no WhatsApp
              </a>
            </li>
            <li>
              <a href="https://painel.sendcube.com.br" className="text-ink/70 hover:text-ink hover:underline">
                Acessar o painel
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-ink/50">Selo</h3>
          <div className="inline-flex items-center gap-2 rounded-lg border-2 border-ink bg-paper px-3 py-2 text-xs font-bold">
            Meta Business Partner
          </div>
        </div>
      </div>

      <div className="border-t border-ink/10 px-5 py-5 text-center text-xs text-ink/50">
        © {new Date().getFullYear()} SendCube. Todos os direitos reservados.
      </div>
    </footer>
  );
}
